export default __webpack_public_path__ + "static/media/113.a5f34663.png";